<template>
  <div>
    <v-toolbar card dense light flat >
      <v-flex>
        <v-layout row>
          <v-icon light v-html="cxt.getTitleIcon()"></v-icon>
          <!-- <v-toolbar-title v-if="!getIsMobile">{{cxt.getTitle()}}</v-toolbar-title> -->
        </v-layout>
        <v-flex v-if="!getIsMobile" pl-3 class="caption" v-html="formatCountTitle"></v-flex>
        <v-flex v-if="getIsMobile" class="caption" v-html="formatCountTitle"></v-flex>
      </v-flex>
        <v-layout v-show="cxt.isFilterMode() && cxt.isSelectMode()" style="overflow:hidden" justify-end>
        </v-layout>
        <v-layout v-show="(cxt.isFilterMode() && cxt.isSelectMode())" style="overflow:hidden" justify-end>
            <v-chip
              v-for="tagId in tagIds"
              :key = tagId
              small
              disabled
              text-color="secondary"
              @click="selectTag()"
              >
              <span class="text-xs-center" v-html="formatTagName(tagId)">
              </span>
            </v-chip>
            <v-chip
              small
              disabled
              text-color="secondary"
              @click="selectTag()"
              v-show="tagIds.length === 0"
              >
              <span class="text-xs-center">
              Метки
              </span>
            </v-chip>
        </v-layout>
        <v-flex sm4 xs4 v-if="cxt.isFilterMode()">
          <v-text-field
            autofocus
            label="Фильтр"
            v-show="cxt.isFilterMode()"
            :value="cxt.filterString"
            v-on:input="onChangeFilter"
            solo flat
          ></v-text-field>
        </v-flex>
    </v-toolbar>
    <v-progress-linear style="margin-top: 0; margin-bottom: 0" height=2 :active="isSearching" :indeterminate="true"></v-progress-linear>
    <v-card-scroll :height="calcDialogScroll(48+48+52+2)" v-on:nextPage="nextPage">
        <v-list
        three-line dense>
          <template v-for="item in this.filteredItems">
            <v-list-tile v-bind:key="getItemKey(item)"  @click.stop="select(item)">
                <v-list-tile-content>
                  <v-list-tile-title v-html="renderReference(item.ref, '_blank')"></v-list-tile-title>
                  <v-list-tile-sub-title>
                  {{renderHeads(item.ref)}}
                  <br/>
                  ИНН: <span v-html="renderInnOrInnflHtml(item.ref.inn)"></span>
                  <span style="white-space: normal;"> {{formats.blank(item.ref.address)}}</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
              <span>
                <v-icon v-show="item.ref.clientId">person</v-icon>
                <v-icon v-show="!item.ref.clientId"></v-icon>
                <v-icon v-if="radio" v-show="cxt.check(getItemKey(item))">radio_button_checked</v-icon>
                <v-icon v-if="radio" v-show="cxt.uncheck(getItemKey(item))">radio_button_unchecked</v-icon>
                <v-icon v-if="!radio" v-show="cxt.check(getItemKey(item))">check_box</v-icon>
                <v-icon v-if="!radio" v-show="cxt.uncheck(getItemKey(item))">check_box_outline_blank</v-icon>
              </span>
              <v-list-tile-action-text>{{formats.blank(item.ref.createDate, formats.formatDate)}}</v-list-tile-action-text>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
    </v-card-scroll>
  </div>
</template>


<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import server from '../../api/server'
  import formats from '../../api/formats'
  import classes from '../../api/classes'
  import apimix from '../common/apimix'
  import dialogs from '../common/dialogs'
  import vCardScroll from '../common/CardScroll'
  import vTagSelector from '../favorite/TagSelector.vue'

  class SelectAllAction extends classes.Action {
    constructor (context) {
      super(context,
        'Выбрать Всех',
        null,
        () => {
          var fxt = this.context.getItemSet.getFilter()
          server.apiGetParams(
            '/api/me/favorite/companies',
            {
              innOnly: true,
              request: {
                search: fxt.search,
                tagIds: fxt.tagIds,
                isShowOther: false,
                isMonitoring: false
              }
            },
            (data) => {
              context.setSelected(data.map(t => t.join('_')))
            },
            (e) => {
            }
          )
        }
      )
    }
  }

  export default {
    name: 'favorite-selector-tab',
    components: {vCardScroll},
    mixins: [apimix],
    data: () => ({
      tagIds: [],
      cxt: null
    }),
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => this.getItemKey(item))
      })
      cxt.mode = classes.modes.SELECT
      cxt.filterMode = true
      this.cxt = cxt
    },
    mounted () {
      this.cxt.filterString = this.query ? this.query : (this.getItemSet ? this.getItemSet.getFilter().search : '')
      this.changeFilterContext({search: this.cxt.filterString})
      this.fetchData()
      this.processMethodsQueue()
    },
    watch: {
      selected (newVal, oldVal) {
        this.cxt.setSelected(newVal)
      },
      methodsQueue () {
        this.processMethodsQueue()
      }
    },
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      radio: {
        type: Boolean,
        default: false
      },
      partner: {
        type: Boolean,
        default: false
      },
      query: {
        type: String,
        default: null
      },
      selected: {
        type: Array,
        default: []
      },
      methodsQueue: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        getItemSet: 'getFavoriteSet',
        getProfileHaveClient: 'getProfileHaveClient',
        renderReference: 'renderReference',
        renderHeads: 'renderHeads',
        calcDialogScroll: 'calcDialogScroll',
        getTags: 'getTags',
        renderInnOrInnflHtml: 'renderInnOrInnflHtml'
      }),
      formatCountTitle () {
        var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано '
        if (this.cxt.isSelectMode()) {
          return this.getSearchTotal > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getSearchTotal + '' : ''
        }
      },
      items () {
        return this.getItemSet.getItems()
      },
      orderedItems () {
        return this.items
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(
              item.ref.caption,
              item.ref.name,
              this.renderHeads(item.ref),
              item.ref.inn,
              item.ref.ogrn,
              item.ref.kpp,
              // this.formatDate(item.ref.createDate),
              // this.formatDate(item.ref.releaseDate),
              item.ref.address,
              item.notes,
              item.privateNotes)
        }
        if ((!this.cxt.isFilterMode()) || (this.cxt.filterString === null)) {
          return this.orderedItems
        }
        let terms = formats.parseSearchTerms(this.cxt.filterString)
        if (terms.length < 1) {
          return this.orderedItems
        }
        return this.orderedItems.filter(item => {
          let searchStr = getSearchString(item).toLowerCase()
          return terms.every(t => (searchStr.includes(t)))
        })
      },
      isSearching () {
        return this.getItemSet.isProcessing()
      },
      getSearchTotal () {
        return this.getItemSet.getTotal()
      }
    },
    methods: {
      processMethodsQueue () {
        if (!this.methodsQueue) return
        let len = this.methodsQueue.length
        for (let i = 0; i < len; i++) {
          let method = this.methodsQueue.shift()
          if (this[method.name]) {
            this[method.name](method.params)
          }
        }
      },
      checkAll () {
        let action = new SelectAllAction(this)
        action.run()
      },
      nextPage () {
        this.$store.commit('nextFavoriteCompanies')
        this.$store.dispatch('fetchFavoriteCompanies')
      },
      changeFilterContext (ops, force) {
        var self = this
        this.$store.commit('setFavoritesFilterContext', Object.assign({}, this.getItemSet.getFilter(), ops))
        setTimeout(() => {
          self.$store.dispatch('fetchFavoriteCompanies', force)
        }, 500)
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
        if ((this.getProfileHaveClient)) {
          let search = formats.stringifySearchTerms(formats.parseSearchTerms(this.cxt.filterString))
          if (formats.compareString(search, this.getItemSet.getFilter().search) !== 0) {
            this.changeFilterContext({search: search}, true)
            this.$emit('change', e)
          }
        }
      },
      fetchData () {
        if (this.getProfileHaveClient) {
          this.tagIds = this.getItemSet.getFilter().tagIds
          this.changeFilterContext({search: this.cxt.filterString, isShowOther: false, tagIds: this.tagIds}, true)
          this.$store.dispatch('fetchTags')
        }
      },
      getItemKey (item) {
        return item.ref.ref + '_' + item.ref.inn
      },
      select (item) {
        if ((this.partner && !item.ref.clientId)) {
          return
        }
        var uid = this.getItemKey(item)
        if (this.cxt.uncheck(uid)) {
          if (this.radio) {
            this.cxt.clear()
          }
        }
        this.cxt.select(uid)
        this.$emit('input', this.cxt.selected())
      },
      setSelected (ids) {
        this.cxt.setSelected(ids)
        this.$emit('input', this.cxt.selected())
      },
      formatTagName (tagId) {
        var t = this.getTags.find(t => t.id === Math.abs(tagId))
        var n = t ? t.name : ''
        return tagId < 0 ? `- ${n}` : `${n}`
      },
      selectTag () {
        var self = this
        const setItems = function (tagIds) {
          self.tagIds = tagIds
          self.changeFilterContext({tagIds: self.tagIds})
        }
        dialogs.register('v-tag-selector', vTagSelector)
        var fullscreen = this.$vuetify.breakpoint.xsOnly
        var comp = { template: `
          <v-tag-selector v-on:close="$emit('close')"
          v-on:input="setItem"
          :fullscreen="fullscreen" :selected="selected" removeMode></v-tag-selector>
          `,
          data () {
            return {
              fullscreen: fullscreen,
              setItem: setItems,
              selected: self.tagIds
            }
          }
        }
        dialogs.modal(comp)
      }
    }

  }

</script>



// WEBPACK FOOTER //
// FavoriteSelectorTab.vue?1ba59d10